import React from 'react';
import './Disclaimer.css';

const Disclaimer = () => {
  return (
    <div className="disclaimer-page">
      {/* Hero Section */}
      <section className="disclaimer-hero">
        <div className="container">
          <h1 className="disclaimer-hero-title">Disclaimer</h1>
          <p className="disclaimer-hero-subtitle">
            Last updated: January 2026
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="disclaimer-content">
        <div className="container">
          <div className="disclaimer-document">
            <div className="disclaimer-section">
              <h2>General Information</h2>
              <p>
                The information provided by Tinder is for general informational purposes only. All information on the site is provided in good faith, however we make no representation or warranty of any kind, express or implied, regarding the accuracy, adequacy, validity, reliability, availability, or completeness of any information on the site.
              </p>
            </div>

            <div className="disclaimer-section">
              <h2>Not Professional Advice</h2>
              <p>
                The site cannot and does not contain professional advice. The information is provided for general informational and educational purposes only and is not a substitute for professional advice. Accordingly, before taking any actions based upon such information, we encourage you to consult with the appropriate professionals.
              </p>
            </div>

            <div className="disclaimer-section">
              <h2>Use at Your Own Risk</h2>
              <p>
                Your use of the site and your reliance on any information on the site is solely at your own risk. We do not guarantee specific results from the use of our Services.
              </p>
            </div>

            <div className="disclaimer-section">
              <h2>User Safety</h2>
              <p>
                While we implement safety features and policies, users are responsible for their own safety when meeting other users in person. We recommend:
              </p>
              <ul>
                <li>Meeting in public places</li>
                <li>Telling a friend or family member about your plans</li>
                <li>Being cautious about sharing personal information</li>
                <li>Reporting any suspicious behavior</li>
              </ul>
            </div>

            <div className="disclaimer-section">
              <h2>External Links</h2>
              <p>
                The site may contain links to external websites that are not provided or maintained by or in any way affiliated with Tinder. Please note that Tinder does not guarantee the accuracy, relevance, timeliness, or completeness of any information on these external websites.
              </p>
            </div>

            <div className="disclaimer-section">
              <h2>No Guarantees</h2>
              <p>
                Tinder does not guarantee that you will find a match, date, or relationship through our Services. The success of any relationship formed through our platform depends on the individuals involved.
              </p>
            </div>

            <div className="disclaimer-section">
              <h2>Limitation of Liability</h2>
              <p>
                In no event shall Tinder, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your access to or use of or inability to access or use the Services.
              </p>
            </div>

            <div className="disclaimer-section">
              <h2>Contact Us</h2>
              <p>
                If you have any questions about this Disclaimer, please contact us at:
              </p>
              <p>
                <strong>Email:</strong> legal@tinder.com<br />
                <strong>Address:</strong> 8750 N. Central Expressway, Dallas, TX 75231
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Disclaimer;
